export default "__VITE_ASSET__B3tw90eh__"